<template>
  <div class="form-default">
    <header class="b-header">
      <h2 style="margin-bottom: 0">{{ questionTitle }}</h2>
    </header>
    <main style="padding:0" class="b-main">
      <form v-on:submit.prevent="true">
        <div v-for="(question, index) in questions" v-bind:key="question.pos" class="hellob" style="margin-bottom:2rem">
          {{ question.text }}
          <div>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                v-bind:id="'pos-y-' + index"
                v-bind:name="'pos-' + question.pos"
                v-bind:value="'yes'"
                v-on:input="selectRadio($event)"
                class="custom-control-input"
              />
              <label class="custom-control-label" v-bind:for="'pos-y-' + index">{{ $t('yes') }}</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                v-bind:id="'pos-n-' + index"
                v-bind:name="'pos-' + question.pos"
                v-bind:value="'no'"
                v-on:input="selectRadio($event)"
                class="custom-control-input"
              />
              <label class="custom-control-label" v-bind:for="'pos-n-' + index">{{ $t('no') }}</label>
            </div>
          </div>
        </div>
      </form>
    </main>
  </div>
</template>

<i18n>
  {
  "el": {
  "yes": "Ναι",
  "no": "Όχι"
  },
  "en": {
  "yes": "Yes",
  "no": "No"
  }
  }
</i18n>

<script>
export default {
  name: 'FormDefault',
  props: ['questions', 'questionTitle'],
  methods: {
    selectRadio: function($e) {
      /**
       * TODO: DOCUMENT THIS
       * !SHOULD IMPROVE
       */
      const $value = $e.target.value
      const $name = $e.target.name
      const $index = $name.replace('pos-', '')
      const $results = this.$parent.results

      $results[$index] = {
        name: $name,
        value: $value,
        isInverted: this.$parent.questions[$index].isInverted
      }

      document
        .getElementById($e.target.id)
        .closest('.hellob')
        .classList.add('ready')

      if (document.querySelectorAll('.hellob').length === document.querySelectorAll('.hellob.ready').length) {
        this.$parent.showBtn = true
      }
    }
  }
}
</script>
